var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { flatten, isEmpty } from 'lodash';
import useFetchLegacyInventoryStatus from '../../core/apiHooks/useFetchLegacyInventoryStatus';
import { ACURA_SITE_NAME, MODEL_YEAR_API_DEFAULT_VALUE } from '../../utils/constants';
import { useAppName } from '../../utils/sitecoreContext';
/**
 * Maps the fields data for PSP Trimpackages to use a similar object shape for defaultTransmissions.
 *
 * @param {Object} fields - The fields data.
 * @returns {Object} - The fields data with mapped trim packages.
 */
/* eslint-disable no-param-reassign */
export var mapPSPFields = function (fields) {
    var _a, _b, _c, _d, _e, _f;
    if (!((_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) || isEmpty((_b = fields === null || fields === void 0 ? void 0 : fields.data) === null || _b === void 0 ? void 0 : _b.value)) {
        return {};
    }
    // TODO: Cleanup with a proper mapper
    var mappedTrims = flatten((_f = (_e = (_d = (_c = fields === null || fields === void 0 ? void 0 : fields.data) === null || _c === void 0 ? void 0 : _c.value.modelYear) === null || _d === void 0 ? void 0 : _d.fields) === null || _e === void 0 ? void 0 : _e.models) === null || _f === void 0 ? void 0 : _f.map(function (model) {
        var _a;
        return flatten((_a = model === null || model === void 0 ? void 0 : model.trims) === null || _a === void 0 ? void 0 : _a.map(function (trim) {
            trim.defaultTransmission.item = trim.defaultTransmission;
            trim.model = model;
            return trim;
        }));
    }));
    fields.data.value.modelYear.fields.models.trims = mappedTrims;
    return fields;
};
/**
 * Maps the fields data for PE Trimpackages to use a similar object shape for defaultTransmissions.
 *
 * @param {Object} fields - The fields data.
 * @returns {Object} - The fields data with mapped trim packages.
 */
export var mapPEFields = function (fields) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!((_a = fields === null || fields === void 0 ? void 0 : fields.data) === null || _a === void 0 ? void 0 : _a.value) || isEmpty((_b = fields === null || fields === void 0 ? void 0 : fields.data) === null || _b === void 0 ? void 0 : _b.value)) {
        return {};
    }
    var subCategory = (_e = (_d = (_c = fields === null || fields === void 0 ? void 0 : fields.data) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.subCategory) === null || _e === void 0 ? void 0 : _e.fields;
    var trims = (_f = subCategory === null || subCategory === void 0 ? void 0 : subCategory.models) === null || _f === void 0 ? void 0 : _f.map(function (model) {
        var _a;
        return (__assign(__assign({}, model), { 
            // for PE, 'model' is the equivalent of 'trim',
            // base model data
            model: {
                // TODO: base model name for PE?
                modelName: model === null || model === void 0 ? void 0 : model.modelName,
                detKey: model === null || model === void 0 ? void 0 : model.detModelKey,
            }, primaryThumbnail: model === null || model === void 0 ? void 0 : model.primaryImage, modelKey: (_a = model === null || model === void 0 ? void 0 : model.detModelKey) === null || _a === void 0 ? void 0 : _a.value, bodyType: { item: [{ name: subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategoryName.value }] } }));
    });
    return {
        data: {
            value: __assign(__assign({}, fields.data.value), { trimFeatures: (_h = (_g = fields === null || fields === void 0 ? void 0 : fields.data) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.modelFeatures, modelYear: {
                    fields: {
                        category: {
                            name: subCategory === null || subCategory === void 0 ? void 0 : subCategory.name,
                            categoryName: subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategoryName,
                        },
                        year: { value: MODEL_YEAR_API_DEFAULT_VALUE },
                        modelYearPage: subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategoryPage,
                        trims: trims,
                    },
                } }),
        },
    };
};
/**
 * custom hook returns heading font-family for acura and bold font-family otherwise.
 * @returns {string}
 */
export var useAcuraHeadingFontFamily = function () {
    var appName = useAppName();
    var isAcuraSite = appName === ACURA_SITE_NAME;
    return isAcuraSite ? 'heading' : 'bold';
};
/**
 * Replace serializeQuery params with new param
 * @param {*} searchParams current search params
 * @param {*} newParam new param to replace
 * @param {*} asString return as string or object
 * @returns
 */
export var serializeFormQuery = function (searchParams, newParam, asString) {
    if (asString === void 0) { asString = true; }
    var data = {};
    // eslint-disable-next-line no-restricted-syntax
    for (var _i = 0, _a = searchParams.entries(); _i < _a.length; _i++) {
        var pair = _a[_i];
        data[pair[0]] = pair[1];
    }
    if (newParam) {
        data = __assign(__assign({}, data), newParam);
    }
    if (asString) {
        return new URLSearchParams(data).toString();
    }
    return data;
};
export var usePEInventoryStatus = function (trims, shouldFetch) {
    var _a;
    var allTransmissions = shouldFetch
        ? trims === null || trims === void 0 ? void 0 : trims.map(function (trim) { return ({
            modelCode: (trim === null || trim === void 0 ? void 0 : trim.modelCode) || '',
            transmissionKey: trim === null || trim === void 0 ? void 0 : trim.transmissionKey,
            trimKey: trim === null || trim === void 0 ? void 0 : trim.trimKey,
        }); })
        : [];
    var data = useFetchLegacyInventoryStatus(allTransmissions).data;
    if (shouldFetch) {
        (_a = trims === null || trims === void 0 ? void 0 : trims.map) === null || _a === void 0 ? void 0 : _a.call(trims, function (trim, index) {
            var trimWithInventoryStatus = data === null || data === void 0 ? void 0 : data.find(function (t) { return t.trimKey === trim.trimKey; });
            var updatedTrim = __assign(__assign({}, trim), { inventoryStatus: trimWithInventoryStatus === null || trimWithInventoryStatus === void 0 ? void 0 : trimWithInventoryStatus.inventoryStatus });
            trims[index] = updatedTrim;
            return updatedTrim;
        });
    }
};
